import AcademySection from '../Components/AcademySection';


const Academy = () => {
  return (
    <div className='bg-accent-lighter pt-20'>
      <AcademySection />
    </div> 
  )
};

export default Academy;